module.exports = __webpack_public_path__ + "static/media/Desjah.01c73d6a.jpg";